import { DeviceService } from "../fhir/DeviceService";
import { LocationService } from "../fhir/LocationService";
import { PatientService } from "../fhir/PatientService";
import { PractitionerService } from "../fhir/PractitionerService";
import { ActorModel, SupportedActorType } from "../fhir/fhir.types";

export class ActorDirectoryService {
  constructor(
    private readonly patientService: PatientService,
    private readonly practitionerService: PractitionerService,
    private readonly locationService: LocationService,
    private readonly deviceService: DeviceService,
  ) {}

  async search(
    actorType: SupportedActorType,
    query: string,
  ): Promise<ActorModel[]> {
    const actors =
      actorType === "patient"
        ? await this.patientService.searchByName(query)
        : actorType === "practitioner"
          ? await this.practitionerService.searchByName(query)
          : actorType === "location"
            ? await this.locationService.searchByName(query)
            : await this.deviceService.searchByName(query);

    return actors.sort((left, right) => left.display.localeCompare(right.display));
  }
}
